import styled from 'styled-components';

export const InputSwitchStyled = styled.div`
  .theme_input_switch {
    
  }
`;
